import { useFormik } from "formik";
import RadioInput from "../../common/RedioComponent/RadioInput";
import Header from "../../component/Header";
import Layout from "../../component/Layout";
import UsePagination from "../../component/pagination";
import * as S from "./MedicalRecords2.Styles";
import * as yup from "yup";

const MedicalRecords2 = ({ step, setStep }) => {
  const radioOption = [
    { label: "بله", value: "YES" },
    { label: "خیر", value: "NO" },
    { label: "به پزشک در این رابطه مراجعه نکرده‌ام", value: "UNKHNOW" },
  ];
  const checkOption = [
    { label: "بله", value: "true" },
    { label: "خیر", value: "false" },
  ];
  const initialValues = {
    hasPressure: JSON.parse(localStorage.getItem("infoPerson"))[step - 1]
      ? JSON.parse(localStorage.getItem("infoPerson"))[step - 1].hasPressure
      : "",
    pressureDruge: JSON.parse(localStorage.getItem("infoPerson"))[step - 1]
      ? JSON.parse(localStorage.getItem("infoPerson"))[step - 1].pressureDruge
      : "",
  };

  //2.
  const onSubmit = (values) => {
    const datas = JSON.parse(localStorage.getItem("infoPerson"));
    let info = localStorage.getItem("infoPerson");
    if (info) {
      let parseInfo = JSON.parse(info);
      parseInfo[4] = values;
      localStorage.setItem("infoPerson", JSON.stringify(parseInfo));
    } else {
      datas.push(values);
      localStorage.setItem("infoPerson", JSON.stringify(datas));
    }

    localStorage.setItem("step", JSON.stringify(step));
    setStep(
      parseInt(localStorage.getItem("step"))
        ? parseInt(localStorage.getItem("step")) + 1
        : 5
    );
  };

  //3.
  const validationSchema = yup.object().shape({
    hasPressure: yup.string().required("یک مورد را انتخاب کن  "),
    pressureDruge: yup.string().when("hasPressure", {
      is: "YES",
      then: () => yup.string().required("I am required "),
    }),
  });

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });

  return (
    <>
      <Header>
        <S.BgHeader style={{ backgroundImage: `url("images/Header2.png")` }}>
          <S.ContentHeader>
            <S.TitleHeader>سوابق پزشکی</S.TitleHeader>
            <img src="/images/medication.png" width={128} alt="header" />
          </S.ContentHeader>
        </S.BgHeader>
      </Header>
      <Layout>
        <S.Container>
          <S.Title> آیا پزشک برای شما تشخیص فشار خون بالا داده است؟</S.Title>
          <S.RadioWrraper>
            <form
              onSubmit={formik.handleSubmit}
              style={{ marginBottom: "98px" }}
            >
              <RadioInput
                formik={formik}
                name={"hasPressure"}
                radioOption={radioOption}
              />
              {formik.values.hasPressure === "YES" ? (
                <S.Smooke>
                  <S.Title>آیا داروی فشار خون مصرف می‌کنید؟</S.Title>
                  <RadioInput
                    formik={formik}
                    name={"pressureDruge"}
                    radioOption={checkOption}
                  />
                </S.Smooke>
              ) : (
                ""
              )}
              <UsePagination step={step} setStep={setStep} formik={formik} />
            </form>
          </S.RadioWrraper>
        </S.Container>
      </Layout>
    </>
  );
};

export default MedicalRecords2;
